import lang from '@/lang'
import { BookingService } from '@/modules/banking/services/index'
import BankingListModel from '@/modules/banking/components/list/models/banking-list-model'
import { FINANCE_API, BOOKING_ASSISTANT } from '@/modules/banking/constants'
import { getBookingAmount } from '@/modules/banking/components/booking-assignments/_helper/getBookingAmount'

import { toast } from '@/modules/base/components/toast/toastConfig'

const { ASSIGNMENT_STATE: { NOT_ASSIGNED } } = FINANCE_API
const { ASSIGNMENT_CREATED, ASSIGNMENT_REMOVED } = BOOKING_ASSISTANT.UPDATE_TYPES

const initialState = {
  bookings: [],
  contentType: null,
  count: {
    assigned: 0,
    open: 0,
    total: 0,
  },
  currentIndex: 0,
  isLastBooking: false,
  isLoading: false,
  open: false,
  selectedBooking: null,
}

const ACTION_PREFIX = 'banking/bookingAssistant'
const OPEN_ASSISTANT = `${ACTION_PREFIX}/showLoader`
const CLOSE_ASSISTANT = `${ACTION_PREFIX}/hideLoader`
const SET_LOADER = `${ACTION_PREFIX}/setLoader`
const SET_CONTENT_TYPE = `${ACTION_PREFIX}/setContentType`
const UPDATE_SELECTED_BOOKING = `${ACTION_PREFIX}/updateSelectedBooking`
const SET_BOOKINGS = `${ACTION_PREFIX}/setBookings`
const UPDATE_COUNT = `${ACTION_PREFIX}/updateCount`
const RESET_ASSISTANT = `${ACTION_PREFIX}/reset`

export default function bookingAssignmentsReducer(state = initialState, action) {
  switch (action.type) {
    case OPEN_ASSISTANT: {
      return { ...state, open: true }
    }
    case CLOSE_ASSISTANT: {
      return { ...state, open: false }
    }
    case SET_LOADER: {
      const { isLoading } = action
      return { ...state, isLoading }
    }
    case SET_CONTENT_TYPE: {
      const { contentType } = action
      return { ...state, contentType }
    }
    case UPDATE_SELECTED_BOOKING: {
      const { booking: selectedBooking, resetContentType } = action
      const { bookings, contentType } = state
      const currentIndex = bookings.findIndex(booking => booking.id === selectedBooking.id)
      const { amount, categorization: { assignments } } = selectedBooking
      selectedBooking.amountMinusAssignments = getBookingAmount(amount, assignments)

      return {
        ...state,
        selectedBooking,
        currentIndex,
        contentType: resetContentType ? null : contentType,
        isLastBooking: currentIndex + 1 === bookings.length,
        isLoading: false,
      }
    }
    case SET_BOOKINGS: {
      const { bookings } = action

      const openBookings = bookings.filter(booking => booking.assignmentState === NOT_ASSIGNED)
      const count = {
        assigned: bookings.length - openBookings.length,
        open: openBookings.length,
        total: bookings.length,
      }

      return {
        ...state,
        bookings,
        count,
      }
    }
    case UPDATE_COUNT: {
      const { updateType } = action
      const { count } = state
      const newCount = { ...count }

      if (updateType === ASSIGNMENT_CREATED) {
        newCount.open = count.open - 1
        newCount.assigned = count.assigned + 1
      }

      if (updateType === ASSIGNMENT_REMOVED) {
        newCount.open = count.open + 1
        newCount.assigned = count.assigned - 1
      }

      return { ...state, count: newCount }
    }
    case RESET_ASSISTANT: {
      return initialState
    }
    default: {
      return { ...state }
    }
  }
}

export const openAssistant = () => ({ type: OPEN_ASSISTANT })
export const closeAssistant = () => ({ type: CLOSE_ASSISTANT })
export const setLoader = (isLoading) => ({ type: SET_LOADER, isLoading })
export const setContentType = (contentType) => ({ type: SET_CONTENT_TYPE, contentType })
export const updateSelectedBooking = (booking, resetContentType) => ({ type: UPDATE_SELECTED_BOOKING, booking, resetContentType })
export const setBookings = (bookings) => ({ type: SET_BOOKINGS, bookings })
export const updateCount = (updateType) => ({ type: UPDATE_COUNT, updateType })
export const resetAssistant = () => ({ type: RESET_ASSISTANT })

export const setSelectedBooking = (booking, resetContentType) => {
  return (dispatch) => {
    dispatch(setLoader(true))
    BookingService.getDetails(booking.id)
      .then((result) => {
        const bookingModel = new BankingListModel(result.body.data)
        dispatch(updateSelectedBooking(bookingModel, resetContentType))
      })
      .catch(() => {
        toast.showToast({ type: 'error', message: lang.defaultErrorMessage })
      })
      .finally(() => dispatch(setLoader(false)))
  }
}
